import Datepicker from 'vuejs-datepicker';
import lang from "@/views/modules/Opportunitys/language/en";
import alert from "@/views/shared/notify/Alert.vue";
import Editor from '@tinymce/tinymce-vue';
import vSelect from "vue-select";


export default {
    name: "new-opportunity",

    components: {
        Datepicker,
        vSelect,
        'editor': Editor,
        alert
    },
    data() {
        return {
            loading: true,
            opportunity: {
                opportunity_title: '',
                opportunity_scope: '',
                opportunity_funder: '',
                opportunity_funder_link: '',
                country_id: '',
                currency_name:'',
                opportunity_budget: '',
                opportunity_year: '',
                deadline: '',
                proposal_shared_date: '',
                budget_shared_date: '',
                peer_comment_date: '',
                submition_date: '',
            },
            lang: [],
            dateFormat: '',
            dom_array: [],
            fundersList: [],
            country_array: [],
            error_message: {
                title: '',
                scope: '',
                funder: '',
                funder_link: '',
                country: '',
                budget: '',
                year: '',
                deadline: '',
                proposal_shared_date: '',
                budget_shared_date: '',
                peer_comment_date: '',
                submition_date: '',
            },
            process: false,
            disabled: false,
            saveCount: 0,
        }
    },
    computed: {
        // When the Funding Type is "Researcher Recognition", Budget Cap, Duration
        // and the Peer Review Timeline are hidden and saved with defaults.
        isResearcherRecognition() {
            return this.opportunity.opportunity_type === 'Researcher Recognition';
        },
    },
    mounted() {
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
        this.getCountry();
        this.getFunderList();
    },
    methods: {
        SaveOpportunity() {
            const self = this;
            self.saveCount = self.saveCount + 1;

            // Researcher Recognition: the hidden fields (Budget Cap, Duration, Peer
            // Review Timeline) are saved with defaults so validation does not fail.
            if (self.isResearcherRecognition) {
                const today = moment().format('DD/MM/yyyy');
                self.opportunity.currency_name = self.opportunity.currency_name || 'NA';
                self.opportunity.opportunity_budget = '0';
                self.opportunity.opportunity_year = '0';
                self.opportunity.proposal_shared_date = today;
                self.opportunity.budget_shared_date = today;
                self.opportunity.peer_comment_date = today;
                self.opportunity.submition_date = today;
            }

            if (self.opportunity.opportunity_title == '') {
                self.error_message.title = 'Please fill Opportunity Title';
            } else {
                self.error_message.title = '';
            }
            if (self.opportunity.opportunity_scope == '') {
                self.error_message.scope = 'Please fill Opportunity Scope';
            } else {
                self.error_message.scope = '';
            }
            if (self.opportunity.opportunity_funder == '') {
                self.error_message.funder = 'Please fill Opportunity Funder';
            } else {
                self.error_message.funder = '';
            }
            if (self.opportunity.opportunity_funder_link == '') {
                self.error_message.funder_link = 'Please fill Opportunity Funder Link Page';
            } else {
                self.error_message.funder_link = '';
            }
            if (self.opportunity.country_id == '') {
                self.error_message.country = 'Please select Country';
            } else {
                self.error_message.country = '';
            }
            if (self.opportunity.currency_name == '') {
                self.error_message.budget = 'Please select currency for budget';
            } else {
                self.error_message.budget = '';
            }

            if (self.opportunity.opportunity_budget == '') {
                self.error_message.budget = 'Please fill Opportunity Budget';
            } else {
                self.error_message.budget = '';
            }

            if (self.opportunity.opportunity_year == '') {
                self.error_message.year = 'Please fill Opportunity Year';
            } else {
                self.error_message.year = '';
            }
            if (self.opportunity.deadline == '') {
                self.error_message.deadline = 'Please fill Application Deadline';
            } else {
                self.error_message.deadline = '';
            }
          
            if (self.opportunity.proposal_shared_date == '') {
                self.error_message.proposal_shared_date = 'Please fill proposal shared date';
            } else {
                self.error_message.proposal_shared_date = '';
            }

            if (self.opportunity.budget_shared_date == '') {
                self.error_message.budget_shared_date = 'Please fill Peer Review Shared Date';
            } else {
                self.error_message.budget_shared_date = '';
            }

            if (self.opportunity.peer_comment_date == '') {
                self.error_message.peer_comment_date = 'Please fill Peer Review Comment Date';
            } else {
                self.error_message.peer_comment_date = '';
            }

            if (self.opportunity.submition_date == '') {
                self.error_message.submition_date = 'Please fill submition date';
            } else {
                self.error_message.submition_date = '';
            }
               
           if (self.error_message.title == '' && self.error_message.funder == '' && self.error_message.country == '' && self.error_message.budget == '' && self.error_message.year == '' && self.error_message.deadline == '' && self.error_message.proposal_shared_date == ''  && self.error_message.budget_shared_date == '' && self.error_message.peer_comment_date == '' && self.error_message.submition_date == '') { // && self.saveCount == 1
                self.process = true;
                self.disabled = true;
                axios.post('api/modules/opportunitys', self.opportunity).then(function (res) {
                   // console.log(res.data);
                    if (res.data.message != '') {                        
                        self.process = false;
                        self.disabled = false;
                        self.$router.push(`/modules/opportunitys`);
                    }else{
                      
                        self.$refs.notifyMsg.showAlert('Error',res.data.error);
                        self.process = false;
                        self.disabled = false;
                    }
                }).catch(error => {
                    
                    self.loading = false;
                    self.process = false;
                    self.disabled = false;
                    let allerror = document.getElementsByClassName('error');
                    for(let i = 0; i < allerror.length; i++)
                    {
                        allerror[i].innerHTML = '';
                    }
                    let err = localStorage.getItem('Errors');
                    let err_msg = (JSON.parse(err));
                    let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                    Object.keys(err_msg2 || {}).forEach((key) => {
                        let errorval = err_msg2[key];
                       
                        let error_el = document.getElementById(key+"_error");
                            error_el.innerHTML = errorval
                    });
                    localStorage.removeItem('Errors');
                    
                });
           }
        },
        customFormatter(date) {
            return moment(date).format('DD/MM/yyyy');
        },
        getCountry() {
            const self = this;
             window.currentAction = 'list';
                axios.get('api/modules/getcountrylists', { 'all_country': true }).then(function (response) {
                self.country_array = response.data;
            })
        },
        getFunderList() {
            const self = this;
            let searches = {
                status: {
                    key: 'statuc',
                    value: 'Active'
                }
            }
            self.customLoading = 'funder';
            window.currentAction = 'list';
                axios.get('api/modules/funders', { params: { search: searches,callingFrom: 'form' } }).then(function (response) {
                self.fundersList = response.data.items.map(item =>  `${item.name}`);
                self.customLoading = false;
            })
        },
    }
}